import { render, staticRenderFns } from "./RDCOgmAlert.vue?vue&type=template&id=28d82160"
import script from "./RDCOgmAlert.vue?vue&type=script&lang=js"
export * from "./RDCOgmAlert.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports